export default __webpack_public_path__ + "76328917ece56cadcf4d0e50fda03888.svg";